import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyA4zpoJypTKC3t4pm-wlBOqfRMP2Uc6_AE",
  authDomain: "landscaping-service-swg.firebaseapp.com",
  projectId: "landscaping-service-swg",
  storageBucket: "landscaping-service-swg.firebasestorage.app",
  messagingSenderId: "82351537411",
  appId: "1:82351537411:web:3175b7b4c9967ec4f03d36"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};